// 返回数字数组中的重复项
export function arrayDuplicate(arr: number[]) {
  const tmp: number[] = [];
  arr
    .concat()
    .sort()
    .sort(function (a, b): any {
      if (a == b && tmp.indexOf(a) === -1) tmp.push(a);
    });
  return tmp;
}

// 两位小数转为整数（乘100）
export function solveLargeNumber(v: number | string) {
  const n = String(Number(v));
  let res = 0;
  const l = String(n).split(".");
  if (l.length <= 1) {
    res = Number(n) * 100;
  } else if (l[1].length === 1) {
    res = Number(String(n).replace(/\./, "") + "0");
  } else if (l[1].length === 2) {
    res = Number(String(n).replace(/\./, ""));
  } else if (l[1].length > 2) {
    res = Math.ceil(Number(n) * 100);
  } else {
    res = Number(n) * 100;
  }
  return res;
}

// 节流
export function throttle<C, T extends unknown[]>(
  fn: (this: C, ...args: T) => unknown,
  interval: number = 200
) {
  let flag = false;
  return function (this: C, ...args: T): void {
    if (!flag) {
      flag = true;
      setTimeout(() => {
        flag = false;
        fn.call(this, ...args); // this 报语法错误，先用 null
      }, interval);
    }
  };
}

// 换算文件大小,size为number,保留1位小数
export function solveFileSize(size: number) {
  if (size > 1000 * 1000 * 1000) {
    return (size / (1000 * 1000 * 1000)).toFixed(1) + "GB";
  }
  if (size > 1000 * 1000) {
    return (size / (1000 * 1000)).toFixed(1) + "MB";
  }
  if (size > 1024) {
    return (size / 1000).toFixed(1) + "KB";
  } else {
    return size + "B";
  }
}
